<template>
  <CompleteSignupProgress
    :currentStep="currentStep"
    :stepNames="['Set up profile', 'Invite team (optional)']" />
</template>

<script>
import CompleteSignupProgress from '@components/sign-up/complete-signup-progress/CompleteSignupProgress.vue'

export default {
  name: 'CompleteSignupProgressAtlassian',
  components: { CompleteSignupProgress },
  props: {
    currentStep: {
      type: Number,
      required: true
    }
  }
}
</script>
